<template>
  <rect
    :x = "getPreviousLineSegmentsLength"
    :y = "getEditorHeight - 30"
    :width = "Math.max(getThisLineSegmentLength, 0)"
    height = "30"
    :fill = "getCircleColor"
    fill-opacity=".5"
    :id="'slope' + num"
    @mouseover="handleMouseOver"
    @mouseout="handleMouseOut"
    @click="handleClick"
    ref="rect"
  />
  <clipPath :id="getClipId">
    <rect
      :x="getPreviousLineSegmentsLength"
      :y="getEditorHeight - 30"
      :width="Math.max(getThisLineSegmentLength, 0)"
      height="30"
    />
  </clipPath>
  <rect
    :x="getPreviousLineSegmentsLength + 7"
    :y="getEditorHeight - 22"
    width="80"
    height="13"
    fill="white"
    fill-opacity=".85"
  />
  <text
    :x="getPreviousLineSegmentsLength + 10"
    :y="getEditorHeight- 12"
    :clip-path="getClipUrl"
    class="slope-text"
  >
    S{{ num + 1 }}&nbsp;&nbsp;&nbsp;{{ this.filterLength(segment.value).toFixed(2) }}&nbsp;{{ lengthUnit }}
  </text>
  <rect
    :x="getPreviousLineSegmentsLength + 7"
    :y="getEditorHeight - 22"
    width="18"
    height="13"
    fill="none"
    stroke="black"
    stroke-width="1"
  />
  <rect
      ref="slopeArea"
      :x="0"
      :y="getPipeEditorHeight - 30 - slopeAreaHeight"
      :width="getWidth"
      :height="slopeAreaHeight"
      fill="rgba(255,0,0,0)"
      stroke="red"
      stroke-width="0"
      pointer-events="none"
  />
  <line
     :id="'slope-line'+ num"
    :x1 ="getPreviousLineSegmentsLength"
    :y1 = "(getPipeEditorHeight - 30 - (slopeAreaHeight/2)) + this.getSlopeSegmentStartY(this.$props.num)"
    :x2 = "getPreviousLineSegmentsLength + getThisLineSegmentLength"
    :y2 = "(getPipeEditorHeight - 30 - (slopeAreaHeight/2)) + this.getSlopeSegmentEndY(this.$props.num)"
    :style = "getLineColor"
  />
  <line
    :x1 ="getPreviousLineSegmentsLength + getThisLineSegmentLength"
    :y1 = "getEditorHeight"
    :x2 = "getPreviousLineSegmentsLength + getThisLineSegmentLength"
    :y2 = "(getPipeEditorHeight - 30 - (slopeAreaHeight/2))  + this.getSlopeSegmentEndY(this.$props.num)"
    :style = "getLineColor"
  />
  <NESWArrows
    :fill = "getCircleColor"
    pointer-events="visible"
    :transform="getGTranslation"
    @mousedown="handleMouseDown"
    @touchstart="handleMouseDown"
    :id="getCircleID"
    ref="circle"
    direction="all"
  />
  <NESWArrows
    v-show="num === 0"
    :fill = "getCircleColor"
    pointer-events="visible"
    :transform="getStartSlopeGTranslation"
    @mousedown="handleMouseDownInitialOffset"
    @touchstart="handleMouseDownInitialOffset"
    :id="getCircleID"
    ref="circle circle-slope"
    direction="all"
    data-start="true"
  />
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSegmentStore } from '@/store/SegmentStore';
import { useSettingsStore } from '@/store/SettingsStore';
import NESWArrows from '@/components/layout/pipe_editor/pipe_editor_components/NESWArrows';
import * as UnitConversion from '@/services/UnitConversionService';
import { usePrintStore } from '@/store/PrintStore';

export default {
  name: 'slope',
  props: [
    'segment',
    'num'
  ],
  components : {
    NESWArrows,
  },
  data () {
    return {
      x1: 50,
      y1: 250,
      x2: 250,
      y2: 250,
      startCircleX : 0,
      startMouseX: 0,
      startCircleY : 0,
      startMouseY : 0,
      startSlopeValue : 0,
      isInitial : false,
    };
  },
  mounted () {
    document.getElementById('editorHolder').append(this.$refs.circle.$el);
  },
  beforeUnmount () {
    this.$refs.circle.$el.remove();
  },
  computed : {
    slopeAreaHeight () {
      return this.getPipeEditorHeight * .2;
    },
    getPipeEditorHeight () {
      return useSegmentStore().getPipeEditorHeight;
    },
    getWidth () {
      return useInputStore().getPressureFlowChartWidth - (useSegmentStore().LRBuffer * 2);
      // return (document.body.clientWidth * .8) - (useSegmentStore().LRBuffer * 2) ;
    },
    lengthUnit () {
      return useSettingsStore().getLengthUnit;
    },
    getGTranslation () {
      return 'translate(' + parseInt(this.getPreviousLineSegmentsLength + this.getThisLineSegmentLength) + ',' +
          (this.getSlopeSegmentEndY(this.$props.num) + (this.getPipeEditorHeight - 30 - (this.slopeAreaHeight/2))) + ')';
    },
    getStartSlopeGTranslation () {
      return 'translate(0,' + parseInt(this.getSlopeSegmentStartY(this.$props.num) + (this.getPipeEditorHeight - 30 - (this.slopeAreaHeight/2))) + ')';
    },
    getCircleID () {
      return 'slope-circle-' + this.$props.num;
    },
    getEditorHeight () {
      return useSegmentStore().getPipeEditorHeight;
    },
    getPreviousLineSegmentsLength () {
      return useSegmentStore().getPreviousLineSegmentsLength(this.$options.name, this.$props.num) * this.getMagScale;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    getThisLineSegmentLength () {
      return useSegmentStore().getSegmentOfType('slope', this.$props.num).value * this.getMagScale;
    },
    getLineColor () {
      const lineWidth = 3;
      return 'stroke:rgb(' + useSegmentStore().hexToRgb(this.$props.segment.color)  + ');stroke-width:' + lineWidth + ';pointer-events:none';
    },
    getBaseLineColor () {
      return 'stroke:rgb(255,0,0);stroke-width:' + 1 + ';pointer-events:none';
    },
    getCircleColor () {
      if (useSegmentStore().getPatternReferences[this.segment.pattern]) {
        return useSegmentStore().getPatternReferences[this.segment.pattern].url();
      }
      return useSegmentStore().getPatternReferences[0].url();
    },
    getClipId () {
      return 'clip-slope' + '-' + this.$props.num;
    },
    getClipUrl () {
      return 'url(#' + this.getClipId + ')';
    }
  },
  methods: {
    filterLength (length) {
      return UnitConversion.FilterLength(length, useSettingsStore().getLengthUnit);
    },
    highlight () {
      this.$refs.rect.classList.add('selected');
    },
    removeHighlight () {
      this.$refs.rect.classList.remove('selected');
    },
    handleMouseOver (e) {
       e.stopImmediatePropagation();
       const segmentStore = useSegmentStore();
       segmentStore.setSelectedSlopeNum(this.$props.num);
       if (useSegmentStore().getSegments('slope').length === 4) { return; }
       segmentStore.setAllowSplit(true);
    },
    handleMouseOut (e) {
      const segmentStore = useSegmentStore();
      if (!segmentStore.getContextVisible) {
        e.stopImmediatePropagation();
        segmentStore.setAllowSplit(false);
        segmentStore.setSelectedSlopeNum(null);
      }
    },
    handleMouseDown (e) {
      if (usePrintStore().getPrintIsOpen) { return; }
      let event = (e.touches) ? e.touches[0] : e;
      this.startCircleX = this.segment.value;
      this.startMouseX = event.clientX;
      this.isInitial = !!e.currentTarget.dataset.start;
      const segmentStore = useSegmentStore();
      let xy = segmentStore.getTranslateXY(e.currentTarget);
      this.startCircleY = xy.translateY;
      this.startMouseY = event.clientY;
      this.startSlopeValue = this.segment.slope;
      segmentStore.setSelectedSlopeNum(this.num);
      if (event.radiusX) {
        window.addEventListener('touchmove', this.handleMouseMove);
        window.addEventListener('touchend', this.handleMouseUp);
      } else {
        window.addEventListener('mousemove', this.handleMouseMove);
        window.addEventListener('mouseup', this.handleMouseUp);
      }
    },
    handleMouseDownInitialOffset (e) {
      if (usePrintStore().getPrintIsOpen) { return; }
      this.isInitial = true;
      this.handleMouseDown(e);
    },
    handleMouseMove (e) {
      if (e.touches) { e = e.touches[0]; }

      // y-axis
      this.setYAxis(e);
      if (this.isInitial) { return; }

      // x-axis with bounds
      let startValue = this.segment.value;
      let offset = (this.startMouseX - (e.clientX));
      offset = offset / this.getMagScale;
      let newValue = this.startCircleX - offset;
      if (newValue <= 0) { newValue = 1; }
      let diff = newValue - startValue;
      const segmentStore = useSegmentStore();
      let segments = segmentStore.getSegments('slope');
      let nextSegment = segments[this.$props.num + 1];

      // todo: implement last point bounds

      let pipeLength = segmentStore.getAllSegmentLengths('pipe');
      let slopeLength = segmentStore.getAllSegmentLengths('slope');
      slopeLength -= this.segment.value;
      let newSlopeLength = slopeLength + newValue;
      if (newSlopeLength >= pipeLength || this.$props.num < segments.length - 1) {
        if (nextSegment) {
          let newNSValue = nextSegment.value - diff;
          if (newNSValue > 0) {
            nextSegment.value = newNSValue;
            this.segment.value = newValue;
          }
        } else {
          if (this.$props.num === segments.length -1) {
            this.segment.value = newValue;
          }
        }
      } else {
        this.segment.value = pipeLength - slopeLength;
      }
    },
    setYAxis (e) {
      const segmentStore = useSegmentStore();
      let editor = document.getElementById('pipeEditor');
      let MouseDiffY = (this.startMouseY - editor.getBoundingClientRect().top) - (e.clientY - editor.getBoundingClientRect().top );
      let slopeValue = this.startSlopeValue + ((( MouseDiffY )) * .2);
      if (slopeValue < -10) {
        slopeValue = -10;
      }
      if (slopeValue > 10) {
        slopeValue = 10;
      }
      if (!this.isInitial) {
        this.$props.segment.slope = slopeValue;
      } else {
        segmentStore.setSlopeStart( slopeValue );
      }
    },
    getMaxRatio () {
      let maxVertical = this.calculateVerticalHeight(useSegmentStore().getSegments('slope'));
      let maxRatio = ((this.slopeAreaHeight/1) - .5*this.slopeAreaHeight)/(maxVertical);
      if (maxRatio > 1) {
        maxRatio = 1;
      }
      useSegmentStore().setMaxRatio(maxRatio);
      return maxRatio;
    },
    getSlopeSegmentStartY () { // index
       return (useSegmentStore().getSlopeSegmentStartY(this.num) * this.getMaxRatio()); //  + this.slopeAreaHeight/2; // maxRatio; // * (1 * (1 - maxRatio));
    },
    getSlopeSegmentEndY () { // index
       return (useSegmentStore().getSlopeSegmentEndY(this.num) * this.getMaxRatio()); // + this.slopeAreaHeight/2; // maxRatio; // * (1 * (1 - maxRatio)) ;
    },
    calculateVerticalHeight (segments) {
      const store = useSegmentStore();
      if (!Array.isArray(segments) || segments.length === 0) {return 0;}
      let runningY = 0;
      let minY = 0;
      let maxY = 0;
      for (let i = 0; i < segments.length; i++) {
        const deltaY = store.getSlopeSegmentEndY(i);
        runningY += deltaY;
        if (runningY > maxY) {maxY = runningY;}
        if (runningY < minY) {minY = runningY;}
      }
      return maxY - minY;
    },
    handleMouseUp (e) {
      useSegmentStore().setSelectedSlopeNum(null);
      if (e.touches) {
        window.removeEventListener('touchmove', this.handleMouseMove);
        window.removeEventListener('touchend', this.handleMouseUp);
      } else {
        window.removeEventListener('mousemove', this.handleMouseMove);
        window.removeEventListener('mouseup', this.handleMouseUp);
      }
      useInputStore().sprinklerCalc();
    },
    handleClick () {
      const segmentStore = useSegmentStore();
      if (!segmentStore.getAllowSplit) { return; }
      segmentStore.splitSlope(segmentStore.getSplitPosition);
    }
  }
};
</script>

<style scoped>
.slope-text {
  font-family: "Heebo", sans-serif;
  font-size: 65%;
  font-weight: bold;
  user-select: none;
  pointer-events: none;
}
</style>

<style>
.red {
  font: .8em serif;
  fill: black;
  user-select: none;
  pointer-events: none;
}
.selected {
  stroke: black;
  stroke-width: 3px;
}
.circle-slope {
  cursor: move;
}
</style>